// The keeper's own calendar day as YYYY-MM-DD. toISOString alone is UTC,
// which is tomorrow every evening west of Greenwich.
export function localDateIso(d = new Date()) {
  return new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString().slice(0, 10);
}

// The same for a datetime-local input: YYYY-MM-DDTHH:MM in local time.
export function localDateTime(d = new Date()) {
  return new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
}
